import { render, staticRenderFns } from "./DocumentTutorial.vue?vue&type=template&id=77c72904&scoped=true&"
import script from "./DocumentTutorial.vue?vue&type=script&lang=js&"
export * from "./DocumentTutorial.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTutorial.vue?vue&type=style&index=0&id=77c72904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c72904",
  null
  
)

export default component.exports